module.exports = "label {\n  padding-right: 10px;\n}\n\ninput {\n  margin-right: 20px;\n}\n"